/**
 * Which keyboard the reader is on.
 *
 * `navigator.platform` is deprecated and was the only thing deciding
 * whether the hint said ⌘ or ctrl — so on a browser that has dropped it
 * the hint would have thrown rather than guessed. This prefers
 * `userAgentData`, falls back to the user agent string, and ends on the
 * safer default: Windows and Linux are the larger population, and
 * "ctrl" shown to a Mac user is a smaller wrong than "⌘" shown to
 * somebody who does not have that key.
 */
export function isApple(): boolean {
  const data = (navigator as { userAgentData?: { platform?: string } }).userAgentData;
  if (data?.platform) return /mac|ios/i.test(data.platform);
  const legacy = (navigator as { platform?: string }).platform;
  if (legacy) return /mac|iphone|ipad|ipod/i.test(legacy);
  return /mac os x|iphone|ipad/i.test(navigator.userAgent || "");
}

/** The modifier this reader's platform actually uses, for a hint. */
export function modifierLabel(): string {
  return isApple() ? "⌘" : "Ctrl";
}

/**
 * Whether this event carries the "command" modifier, on any platform.
 *
 * Both are accepted everywhere rather than switching on the platform: a
 * Mac user on an external Windows keyboard presses Ctrl, and refusing
 * them is a worse failure than accepting a chord nobody will type.
 */
export function hasCommandModifier(e: KeyboardEvent): boolean {
  return e.metaKey || e.ctrlKey;
}
